import { call, put, takeEvery } from 'redux-saga/effects';
import {
  CASE_TAKE_REFERENCE_WITH_NAMES_BEGIN,
  CASE_TAKE_REFERENCE_WITH_NAMES_SUCCESS,
  CASE_TAKE_REFERENCE_WITH_NAMES_FAILURE,
  CASE_TAKE_REFERENCE_WITH_NAMES_DISMISS_FEEDBACK,
} from './constants';
import {
  createPromiseAction,
  resolvePromiseAction,
  rejectPromiseAction,
} from '@adobe/redux-saga-promise';
import api from 'common/api';
import { copyExhibitNumberToClipboard } from './copyExhibitNumberToClipboard';
import { withCurrentCaseId } from 'common/selectors';
import { updateDocumentMeta } from './updateDocumentMeta';

export const takeReferenceWithNames = createPromiseAction(
  CASE_TAKE_REFERENCE_WITH_NAMES_BEGIN,
  (fileId, options = {}) => ({
    fileId,
    ...options,
  }),
);

export function dismissTakeReferenceWithNamesFeedback() {
  return {
    type: CASE_TAKE_REFERENCE_WITH_NAMES_DISMISS_FEEDBACK,
  };
}

export function* doTakeReferenceWithNames(action) {
  const {
    payload: { fileId, caseId, fileName },
  } = action;

  const res = yield call(api.post, `/cases/${caseId}/files/${fileId}/exhibit-number`);

  if (res && res.error) {
    yield put({
      type: CASE_TAKE_REFERENCE_WITH_NAMES_FAILURE,
      feedback: {
        message: typeof res.error === 'string' ? res.error : 'case.takeReferenceWithNamesFailure',
        params: { fileId },
        error: res.error,
        retryAction: action,
      },
      fileId,
    });
    return yield call(rejectPromiseAction, action, res.error);
  }

  const exhibitNumber = res?.exhibitNumber ?? res?.data?.exhibitNumber;
  const safeFileName = (fileName || '').trim();
  const copyText = exhibitNumber
    ? safeFileName
      ? `{${exhibitNumber}/${safeFileName}}`
      : `{${exhibitNumber}}`
    : null;
  const linkHref =
    typeof window !== 'undefined'
      ? `${window.location.origin}/case/${caseId}/files/${fileId}`
      : null;

  if (copyText) {
    yield call(copyExhibitNumberToClipboard, copyText, linkHref);
  }

  const fileMetaPayload = res?.data ?? res;
  if (fileMetaPayload && Object.keys(fileMetaPayload).length) {
    yield put(updateDocumentMeta(fileMetaPayload, fileId));
  }

  yield put({
    type: CASE_TAKE_REFERENCE_WITH_NAMES_SUCCESS,
    feedback: {
      message: 'case.takeReferenceWithNamesSuccess',
      params: { fileId },
      success: true,
      data: res,
    },
  });
  return yield call(resolvePromiseAction, action, res);
}

export function* watchTakeReferenceWithNames() {
  yield takeEvery(takeReferenceWithNames, withCurrentCaseId(doTakeReferenceWithNames));
}

export function reducer(state, action) {
  switch (action.type) {
    case CASE_TAKE_REFERENCE_WITH_NAMES_BEGIN + '.TRIGGER':
      return {
        ...state,
        takeReferenceWithNamesPending: true,
        takeReferenceWithNamesFeedback: null,
        takeReferenceWithNamesResult: null,
      };

    case CASE_TAKE_REFERENCE_WITH_NAMES_SUCCESS:
      return {
        ...state,
        takeReferenceWithNamesPending: false,
        takeReferenceWithNamesFeedback: action.feedback,
        takeReferenceWithNamesResult: action.feedback?.data,
      };

    case CASE_TAKE_REFERENCE_WITH_NAMES_FAILURE:
      return {
        ...state,
        takeReferenceWithNamesPending: false,
        takeReferenceWithNamesFeedback: action.feedback,
        takeReferenceWithNamesResult: null,
      };

    case CASE_TAKE_REFERENCE_WITH_NAMES_DISMISS_FEEDBACK:
      return {
        ...state,
        takeReferenceWithNamesFeedback: null,
        takeReferenceWithNamesResult: null,
      };

    default:
      return state;
  }
}
